import { ListBase } from '../tools/ListBase';

class Emails extends ListBase {

  constructor ({props, context}) {
    super();
    this.state = {rows: [], cls: 'emails'};
    this.title = 'Emails';
    this.state.columns = [
      {
        field: 'Config',
        headerName: 'Email',
        width: 250,
      },
    ];
  }
}


import { useNavigate } from 'react-router-dom';

function EmailsWithNavigate(props) {
  const navigate = useNavigate();
  return <Emails {...props} navigate={navigate} />;
}

export default EmailsWithNavigate;